<template>
  <div ref="parallaxRef" class="fx-parallax-slot">
    <slot />
  </div>
</template>

<script setup>
import { useWindowSize } from '@vueuse/core';

const props = defineProps({
    distance: {
        type: String,
        default: '30vh',
    },

    overscrollDistance: {
        type: String,
        default: '0',
    },

    start: {
        type: String,
        default: 'top bottom',
    },

    end: {
        type: String,
        default: 'bottom top',
    },

    breakpoints: {
        type: Object,
        default: () => ({}),
    },

    debug: {
        type: Boolean,
        default: false,
    },
});

const parallaxRef = ref('parallaxRef');

const parallaxProgress = shallowRef(0);
provide('parallaxProgress', parallaxProgress);

const getResolvedValue = (prop) => {
    if (isGreaterThanDesktop.value) return props.breakpoints.desktop?.[prop] || props[prop];
    if (isGreaterThanTablet.value) return props.breakpoints.tablet?.[prop] || props[prop];
    if (isGreaterThanTabletPortrait.value) {
        return props.breakpoints.tabletPortrait?.[prop]
          || props[prop];
    }
    return props[prop];
};

const resolvedDistance = computed(() => getResolvedValue('distance'));
const resolvedOverscrollDistance = computed(() => getResolvedValue('overscrollDistance'));
const resolvedStart = computed(() => getResolvedValue('start'));
const resolvedEnd = computed(() => getResolvedValue('end'));
let scrollTriggerInstance = null;

const initializeScrollTrigger = async () => {
    // const { gsap } = await useGsap();

    const fromY = resolvedDistance.value;
    const toY = resolvedOverscrollDistance.value;

    if (scrollTriggerInstance) {
        scrollTriggerInstance.kill();
    }

    scrollTriggerInstance = GSAP.fromTo(
        parallaxRef.value,
        { y: fromY },
        {
            y: toY,
            scrollTrigger: {
                trigger: parallaxRef.value,
                scrub: true,
                start: resolvedStart.value,
                end: resolvedEnd.value,
                markers: props.debug,
                onUpdate: ({ progress }) => {
                    parallaxProgress.value = progress;

                    if (props.debug) {
                        console.log('progress', progress);
                    }
                },
            },
        },
    );
};

onMounted(initializeScrollTrigger);

onUnmounted(() => {
    if (scrollTriggerInstance) {
        scrollTriggerInstance.kill();
    }
});

const { width } = useWindowSize();
watch(() => width, () => {
    scrollTriggerInstance.scrollTrigger.refresh();
});

watch([
    resolvedDistance,
    resolvedOverscrollDistance,
    resolvedStart,
    resolvedEnd,
], () => {
    initializeScrollTrigger();
});
</script>

  <style lang="scss" scoped>
    .fx-parallax-slot {
        transition: transform 0.1s ease-out;
        will-change: transform;
    }
  </style>
